module.exports = __webpack_public_path__ + "img/Manu_Q_.7aeef67a.png";